import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Preloading from "../../../components/basics/Preloading";
import methods from "../../../services/utility";
import back from "../../../assets/images/icons/arrow-right2.svg";
import apiMethod from "../../../services/api-service";
import DeleteModal from "../../../components/deleteModal/DeleteModal";
import EditIcon from "../../../assets/images/icons/editIcon.svg";
import DeleteIcon from "../../../assets/images/icons/deleteIcon.svg";
import newLogo from "../../../assets/images/icons/new.png";
import copy from "../../../assets/images/icons/copy.png";
import Paginations from "../../../components/paginaton/Paginations";

const SupplierWarehouse = () => {
  const { restaurantId } = useParams();
  const [loading, setLoading] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [selectId, setSelectId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [filterModel, setFilterModel] = useState({
    title: "",
    restaurantId: restaurantId,
    size: 10,
    part: 1,
    parts: 0,
    total: 0,
  });
  const [formModel, setFormModel] = useState({
    id: 0,
    title: "",
    description: "",
    nationalCode: "",
    phone: "",
    branchId: null,
    restaurantId: restaurantId,
  });

  const getGridData = async (customPart = null) => {
    const part = customPart ? customPart : filterModel.part;
    setLoading(true);
    const resp = await apiMethod.getSuppliers(
      filterModel.restaurantId,
      filterModel.title,
      filterModel.size,
      part
    );
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }
    filterModel.total = resp.total;
    filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
    filterModel.part = part;
    setFilterModel({ ...filterModel });
    setGridData(resp.data);
    setLoading(false);
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getGridData();
      setLoading(false);
    };
    bindData();
  }, []);

  const resetFilters = () => {
    filterModel.restaurantId = restaurantId;
    filterModel.title = "";
    filterModel.size = 10;
    filterModel.part = 1;
    filterModel.parts = 0;
    filterModel.total = 0;
    setFilterModel({ ...filterModel });
  };

  const resetForm = () => {
    formModel.branchId = null;
    formModel.restaurantId = restaurantId;
    formModel.id = 0;
    formModel.nationalCode = "";
    formModel.phone = "";
    formModel.description = "";
    formModel.title = "";
    setFormModel({ ...formModel });
  };

  const closeSupplierModal = () => {
    resetForm();
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };
  const clearSearch = async () => {
    setLoading(false);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    resetForm();
  };

  const selectَItemToDelete = (item) => {
    setSelectId(item);
    setShowDeleteModal(true);
  };

  const deleteItem = async () => {
    setLoading(true);
    const resp = await apiMethod.removeSupplier(selectId.id);
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }
    await getGridData();
    resetForm();
    setLoading(false);
    setShowDeleteModal(false);
  };

  const callPager = async (i) => {
    setLoading(true);
    setFilterModel({ ...filterModel, part: i });
    await getGridData(i);
    setLoading(false);
  };

  const createItem = async () => {
    setLoading(true);
    const resp = await apiMethod.createSupplier(formModel);
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }
    await getGridData();
    resetForm();
    setLoading(false);
  };

  const editItem = async (id) => {
    setLoading(true);
    const resp = await apiMethod.getSupplierInfo(id);
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }
    formModel.id = resp.data.id;
    formModel.title = resp.data.title;
    formModel.phone = resp.data.phone;
    formModel.nationalCode = resp.data.nationalCode;
    formModel.description = resp.data.description;
    setFormModel({ ...formModel });
    setLoading(false);
  };

  const copyItem = (item) => {
    formModel.title = item.title;
    formModel.description = item.description;
    formModel.nationalCode = item.nationalCode;
    formModel.phone = item.phone;
    setFormModel({ ...formModel });
    const el = document.getElementById("add_item");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const renderSupplier = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className="d-none d-lg-block mb-3">
              <Link
                to={`/warehouse/${restaurantId}`}
                className="text-start mb-3 link back-link"
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>
                <Link
                  to={`/warehouse/${restaurantId}`}
                  className="link back-link"
                >
                  <span>
                    <img src={back} className="" alt="return" />
                  </span>
                </Link>
                تامین کننده
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>
                تامین کننده
                <a
                  href={`/wareHouse/${restaurantId}/`}
                  className="link rtlicon me-1"
                  title="برای اطلاعات بیشتر کلیک کنید"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            <div className="salemain mb-3" id="add_item">
              <div className="d-flex align-items-center gap-4 justify-content-end">
                <button className="btn-action" onClick={resetForm}>
                  <img src={newLogo} alt="Image" />
                  <span style={{ fontSize: "12px" }}>جدید</span>
                </button>
              </div>
              <div className="mb-3">
                <span className="fw-bold fs-5">
                  افزودن / ویرایش تامین کننده
                </span>
              </div>
              <div className="row g-3">
                <div className="col-12 col-md-4 mb-4">
                  <label htmlFor="title" className="form-label required-label">
                    عنوان تامین کننده
                  </label>
                  <input
                    className="form-control input-form"
                    type="text"
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={formModel.title}
                    onChange={(e) =>
                      setFormModel({ ...formModel, title: e.target.value })
                    }
                    placeholder="عنوان تامین کننده را بنویسید"
                  />
                </div>
                <div className="col-12 col-md-4 mb-4">
                  <label
                    htmlFor="nationalCode"
                    className="form-label required-label"
                  >
                    کد ملی
                  </label>
                  <input
                    className="form-control input-form"
                    id="nationalCode"
                    type="text"
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={formModel.nationalCode}
                    onChange={(e) =>
                      setFormModel({
                        ...formModel,
                        nationalCode: e.target.value,
                      })
                    }
                    placeholder="کد ملی را بنویسید"
                  />
                </div>
                <div className="col-12 col-md-4 mb-4">
                  <label htmlFor="phone" className="form-label">
                    شماره تماس
                  </label>
                  <input
                    className="form-control input-form"
                    id="phone"
                    type="text"
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={formModel.phone}
                    onChange={(e) =>
                      setFormModel({ ...formModel, phone: e.target.value })
                    }
                    placeholder="شماره تماس  را بنویسید"
                  />
                </div>
                <div className="col-12">
                  <label htmlFor="title" className="form-label">
                    توضیحات
                  </label>
                  <textarea
                    className="form-control input-textarea"
                    type="text"
                    rows={4}
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={formModel.description}
                    onChange={(e) =>
                      setFormModel({
                        ...formModel,
                        description: e.target.value,
                      })
                    }
                    placeholder="توضیحات را بنویسید"
                  ></textarea>
                </div>
                <div class="d-flex align-items-center justify-content-end gap-3 mt-4">
                  <button
                    type="button"
                    class="btn custome-btn btn-link-purple"
                    onClick={closeSupplierModal}
                  >
                    انصراف
                  </button>
                  <button
                    type="button"
                    class="btn custome-btn btn-purple"
                    onClick={createItem}
                  >
                    ثبت و ذخیره
                  </button>
                </div>
              </div>
            </div>
            <div className="salemain mb-3">
              <div className="row align-items-end g-3">
                <div className="col-3">
                  <label htmlFor="title" className="form-label required-label">
                    عنوان
                  </label>
                  <input
                    className="form-control input-form"
                    type="text"
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={filterModel.title}
                    onChange={(e) =>
                      setFilterModel({
                        ...filterModel,
                        title: e.target.value,
                      })
                    }
                    placeholder="جتسجو کنید..."
                  />
                </div>
                <div className="col-2">
                  <div className="d-flex align-items-center gap-2">
                    <button
                      className="btn-wrap search-btn"
                      onClick={searchItem}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                    <button
                      className="btn-wrap reset-btn"
                      onClick={clearSearch}
                    >
                      <i className="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="salemain">
              <span className="d-block text-start fw-bold fs-5">
                تامین کننده
              </span>
              <div className="table-responsive warhousetable">
                <table className="table table-md table-custom">
                  <thead className="align-middle">
                    <tr>
                      <th scope="col vertical-center" width="20px">
                        ردیف
                      </th>
                      <th scope="col vertical-center">عنوان</th>
                      <th scope="col vertical-center">کد ملی</th>
                      <th scope="col vertical-center">شماره</th>
                      <th scope="col vertical-center">توضیحات</th>
                      <th scope="col vertical-center">اقلام</th>
                      <th scope="col vertical-center">عملیات</th>
                    </tr>
                  </thead>
                  <tbody className="align-middle">
                    {gridData.map((item, index) => (
                      <tr key={item.id}>
                        <th scope="row">
                          {(filterModel.part - 1) * filterModel.size +
                            index +
                            1}
                        </th>
                        <td>{item.title}</td>
                        <td>{item.nationalCode}</td>
                        <td>{item.phone}</td>
                        <td>{item.description}</td>
                        <td>
                          <Link
                            to={`/warehouse/${restaurantId}/supplierProducts/${item.id}`}
                          >
                            <button className="btn btn-purple btn-sm">
                              افزودن اقلام
                            </button>
                          </Link>
                        </td>
                        <td className="d-flex align-items-center justify-content-center gap-2">
                          <button
                            className="button-action copy-btn"
                            onClick={() => copyItem(item)}
                          >
                            <img src={copy} alt="Copy" />
                          </button>
                          <button
                            onClick={() => editItem(item.id)}
                            className="button-action"
                            type="button"
                          >
                            <img src={EditIcon} alt="Edit" />
                          </button>
                          <button
                            onClick={() => selectَItemToDelete(item)}
                            className="button-action"
                            type="button"
                          >
                            <img src={DeleteIcon} alt="delete" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {filterModel.parts > 1 && (
                  <div className="pagination justify-content-center mt-5">
                    <Paginations
                      total={filterModel.total}
                      size={filterModel.size}
                      onPageChange={callPager}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        }
      </>
    );
  };

  return (
    <>
      {renderSupplier()}
      {showDeleteModal && (
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeDeleteModal}
          deleteItem={deleteItem}
          text={"انبار"}
        />
      )}
    </>
  );
};

export default SupplierWarehouse;
